//ie対応版

var accBtn = document.querySelectorAll('.things__innerBlockRowHeader');
Array.prototype.forEach.call(accBtn,function (accBtnList) {
    accBtnList.addEventListener('click', toggleAccordion);
});

function toggleAccordion() {
    var rows = document.querySelectorAll('.things__innerBlockRow');
    var thisRow = this.parentNode;
    Array.prototype.forEach.call(rows,function (row) {
        if (thisRow == row) {
            thisRow.classList.toggle('is-on');
            return;
        }

        row.classList.remove('is-on');
    });

    if (thisRow.classList.contains("is-on")) {
        ScrollWindow(thisRow);
    }
}

;

function ScrollWindow(element) {
    setTimeout(function () {
        var rect = element.getBoundingClientRect();
        var minus = document.getElementById("header").clientHeight;
        var elemtop = rect.top + window.pageYOffset - minus;
        document.documentElement.scrollTop = elemtop;
    }, 300);
}

var pathname = location.pathname;

if (pathname === "/news/" || pathname.indexOf("/news/") === 0) {
    var cat = document.querySelector('.catArea');
    var catBtn = document.querySelector('.catArea__header');
    catBtn.addEventListener('click', function () {
        cat.classList.toggle('is-on');
    });
}

// const accBtn = document.querySelectorAll('.things__innerBlockRowHeader');

// accBtn.forEach((accBtnList) => {
//     accBtnList.addEventListener('click', toggleAccordion);
// });

// function toggleAccordion() {
//     const rows = document.querySelectorAll('.things__innerBlockRow');
//     const thisRow = this.parentNode;

//     rows.forEach(row => {
//         if (thisRow == row) {
//             thisRow.classList.toggle('is-on');
//             return;
//         }
//         row.classList.remove('is-on');
//     });
//     if (thisRow.classList.contains("is-on")) {
//         ScrollWindow(thisRow);
//     }
// };

// function ScrollWindow(element) {
//     setTimeout(function () {
//         var rect = element.getBoundingClientRect();
//         var minus = document.getElementById("header").clientHeight;
//         var elemtop = rect.top + window.pageYOffset - minus;
//         document.documentElement.scrollTop = elemtop;
//     }, 300)
// }

// // accBtn.forEach((accBtnList) => {
// //     accBtnList.addEventListener('click', () => {
// //         accBtnList.parentNode.classList.toggle('is-on');
// //     });
// // });

// const pathname = location.pathname;
// if (pathname === "/news/" || pathname.indexOf("/news/") === 0) {
//     const cat = document.querySelector('.catArea');
//     const catBtn = document.querySelector('.catArea__header');

//     catBtn.addEventListener('click', () => {
//         cat.classList.toggle('is-on');
//     });
// }